// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ytAUw","inner":"Footer_inner__3etcL","nextIcon":"Footer_nextIcon__29Mur","innerLeft":"Footer_innerLeft__23BMg"};